import { useEffect } from "react";
import "../../styles/scss/tooltipV2.scss";
import AppSettings from "../../appsettings.js";

export const TooltipV2 = (props) => {
  const { variant = "modal", positionStyle } = props;

  useEffect(() => {
    props.analyticsOpenTooltip
      ? props.analyticsOpenTooltip()
      : console.log("Tooltip is missing analytics function when opened");
  }, []);

  const closeButtonClick = () => {
    props.closeTooltip();
    props.analyticsCloseTooltip
      ? props.analyticsCloseTooltip()
      : console.log("Tooltip is missing analytics function when closed");
  };

  const moreButtonClick = () => {
    props.analyticsMoreClick
      ? props.analyticsMoreClick()
      : console.log(
          "Tooltip is missing analytics function when MORE is clicked",
        );
    props.moreLinkFunction();
  };

  const TooltipContent = ({ className = "", style }) => (
    <div className={`tooltipV2 ${className}`.trim()} style={style}>
      {props.closeTooltip ? (
        <div
          className="tooltipCloseButton"
          onClick={(event) => {
            event.stopPropagation();
            closeButtonClick();
          }}
        >
          <img
            className="closeIcon"
            src={`${AppSettings.AWSImgRepo.resources}en/icon_close_black.svg`}
            alt="Close"
          />
        </div>
      ) : null}
      <div className="tooltipContent">
        {props.title && <div className="tooltip-title">{props.title}</div>}
        {props.subtitle && (
          <div className="tooltip-subtitle">{props.subtitle}</div>
        )}
        {props.description && (
          <div className="tooltip-descriptionBody">
            <span className="tooltip-descriptionText">{props.description}</span>
          </div>
        )}
        {props.moreLinkFunction && (
          <a
            className="tooltip-moreLink"
            onClick={(event) => {
              event.stopPropagation();
              moreButtonClick();
            }}
          >
            {props.moreLinkCTA || "Learn More"}
          </a>
        )}
      </div>
    </div>
  );

  const useModal = variant === "modal";

  if (useModal) {
    return (
      <div
        className="tooltip-overlay"
        onClick={() => {
          closeButtonClick();
        }}
      >
        <div
          className="tooltip-container"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <TooltipContent />
        </div>
      </div>
    );
  }

  if (variant === "floater") {
    return (
      <div className="tooltip-container tooltip-container--floater">
        <TooltipContent className="tooltipV2--floater" style={positionStyle} />
      </div>
    );
  }

  return (
    <div className="tooltip-container" style={positionStyle}>
      <TooltipContent />
    </div>
  );
};
